import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-empty-inbox',
  templateUrl: './empty-inbox.component.html',
  styleUrls: ['./empty-inbox.component.less'],
  standalone: false
})
export class EmptyInboxComponent {
  @Input() textCode: string;
}
